import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useUser } from '../utils/hooks/useUser';

const NewLanding = () => {
  const navigate = useNavigate();
  const { userEmail } = useUser();

  const features = [
    {
      id: 'improve-resume',
      title: 'Improve Resume',
      description: 'AI-powered resume optimization tailored to your target job description',
      icon: '📄',
      color: 'bg-blue-500',
      hoverColor: 'hover:bg-blue-600',
      route: '/improve-resume'
    },
    {
      id: 'mock-interview',
      title: 'Mock Interview',
      description: 'Practice with AI-driven interviews to boost your confidence',
      icon: '🎤',
      color: 'bg-green-500',
      hoverColor: 'hover:bg-green-600',
      route: '/MockInterview'
    }
  ];

  const handleFeatureClick = (route) => {
    navigate(route);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gray-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Welcome!
            </h1>

            <p className="text-lg text-gray-600 mb-4 max-w-3xl mx-auto">
              Choose a tool to get started with your career journey.
            </p>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {features.map((feature) => (
            <div
              key={feature.id}
              onClick={() => handleFeatureClick(feature.route)}
              className="bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer transform hover:scale-105 p-8 text-center"
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 mb-6">{feature.description}</p>
                             <button className={`${feature.color} ${feature.hoverColor} text-white px-6 py-3 rounded-lg font-medium transition-colors`}>
                 Start Now
               </button>
            </div>
          ))}
        </div>
      </div>



      {/* Simple Footer */}
      <div className="bg-white border-t mt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="text-center">
            <Link to="/contact" className="text-gray-600 hover:text-gray-900 text-sm">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewLanding; 